export default __webpack_public_path__ + "static/media/notification_active.9535f69e.svg";